import {Fragment} from 'react';

import {TransferLogs} from '../component/TransferLogs';

export default function HoaDon() {

  return (
    <Fragment>
      <TransferLogs type="Invoice,InvoiceCode,InvoiceCash" showInvoiceInfo={true}/>
    </Fragment>
  );
}
